import { Component } from '@angular/core';
import { AccountService } from '../../../models/account/accountService';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { Account } from '../../../models/account/account';
import { SearchFilters } from '../../../models/search/searchFilters';
import { StorageService } from '../../../core/storage/storageService';
import { Router } from '@angular/router';
import { UIHelpers } from '../../../core/ui-helpers';
import { UIErrorHandler } from '../../../core/uiErrorHandler';

@Component({
  selector: 'app-account-table-view',
  templateUrl: './account-table-view.component.html',
  standalone: false,
})
export class AccountTableViewComponent extends TableViewAbstractComponent {
  constructor(
    public accountService: AccountService,
    private storage: StorageService,
    private router: Router,
    private uiHelpers: UIHelpers,
    private uiErrorHandler: UIErrorHandler,
  ) {
    super();
  }

  getRecordFromDataSource(accountId: string): Account {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == accountId) {
        return this.dataSource.data[i];
      }
    }

    throw 'Account not found in dataset';
  }

  getPageOfData(
    query: string,
    filters: SearchFilters,
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<Account>> {
    return this.accountService.getPaged(query, {
      pageNum: pageNum,
      pageSize: pageSize,
      orderBy: 'account_name',
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      userId: this.options.userId ? this.options.userId : '',
    });
  }

  canQuery(): boolean {
    return true;
    //return this.options.merchantId != ""
  }

  // btnManageAccount_click(id: string) {
  //   if (this.options.selectAction != "none") {
  //     this.selectRow_click(id);
  //   }
  // }

  btnManageAccount_click(id: string) {
    this.accountService
      .getAccount(id)
      .then((b) => {
        this.storage.setSelectedAccount(b);
        this.uiHelpers.selectAccount(new Account(b));
        this.router.navigateByUrl('account');
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }
}
